import Button from "@/components/Button";
import SafeArea from "@/components/safe-area";
import {
	Drawer,
	DrawerClose,
	DrawerContent,
	DrawerDescription,
	DrawerFooter,
	DrawerHeader,
	DrawerTitle,
} from "@/components/ui/drawer";

import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from "@/components/ui/modal";

import useMobile from "@/hooks/useMobile";

import { memo } from "react";

interface Props {
	visible: boolean;
	onClose: () => void;
	onOk: () => void;
	onLoading?: boolean;
	onOkText: string;
	onCancelText: string;
	onCancel: () => void;
	title?: string | React.ReactNode;
	children?: string | React.ReactNode;
}

const ConfirmModal = memo<Props>((props) => {
	const isMobile = useMobile();

	if (isMobile) {
		return (
			<Drawer open={props.visible} onClose={props.onClose}>
				<DrawerContent>
					<div className="mx-auto w-full">
						<DrawerHeader>
							<DrawerTitle className="text-center text-xl font-semibold">{props.title}</DrawerTitle>
							<DrawerDescription></DrawerDescription>
						</DrawerHeader>
						<div className="text-center text-sm font-semibold px-4.5 pb-4">{props.children}</div>
						<DrawerFooter className="px-6">
							<Button block onClick={props.onOk} loading={props.onLoading} id="confirm">
								{props.onOkText}
							</Button>
							<DrawerClose asChild>
								<Button onClick={props.onCancel} type="bordered" block id="cancel">
									{props.onCancelText}
								</Button>
							</DrawerClose>
							<SafeArea position="bottom" />
						</DrawerFooter>
					</div>
				</DrawerContent>
			</Drawer>
		);
	}

	return (
		<Dialog open={props.visible} onOpenChange={(open) => !open && props.onClose()}>
			<DialogTrigger asChild className="h-0 overflow-hidden"></DialogTrigger>
			<DialogContent className="w-[484px]" showClose={false}>
				<DialogHeader>
					<DialogTitle className="text-center">{props.title}</DialogTitle>
					<DialogDescription className="h-0 overflow-hidden"></DialogDescription>
				</DialogHeader>

				<div className="text-center text-sm font-semibold px-4.5 pb-4">{props.children}</div>
				<DialogFooter className="px-4">
					<div className="flex items-center space-x-4 w-full">
						<Button className="whitespace-nowrap" onClick={props.onCancel} type="bordered" block id="cancel">
							{props.onCancelText}
						</Button>

						<Button block onClick={props.onOk} loading={props.onLoading} id="confirm">
							{props.onOkText}
						</Button>
					</div>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
});

ConfirmModal.displayName = "ConfirmModal";
export default ConfirmModal;
